import {builder} from 'san-update';
import axios from 'axios';
import axiosJsonp from 'axios-jsonp';
import {loginAPI} from '../service/api';
import log from './log';
import tts from './tts';

export default {
    ...log,
    ...tts,
    'news:updateLoginInfo'(data, {dispatch}) {
        if (data && data.username) {
            return builder().set('common.isLogin', true);
        }
        return builder().set('common.isLogin', false);
    },
    'news:updateTopBar'(data) {
        if (data) {
            return builder().set('topbar', {
                islogin: !!data.username,
                username: data.username,
                hideLoginInfo: false,
                avatar: data.avatar
            });
        }
    },
    'news:updateLogin'(data, {dispatch, getState}) {
        axios({
            url: loginAPI,
            adapter: axiosJsonp,
            callbackParamName: 'cb'
        }).then(({data}) => {
            dispatch('news:updateTopBar', data);
            dispatch('news:updateLoginInfo', data);
            dispatch('news:pageShowLog');
            dispatch('tts:init');
        });
    }
};
